import { getUrl } from '@buffer-mono/shared-utils/bibe'

import { navigateTo } from '~publish/helpers/navigation'

export const getBillingUrl = (cta?: string): string => {
  const baseUrl = getUrl('https://publish.buffer.com/settings/billing')
  return cta ? `${baseUrl}?cta=${encodeURIComponent(cta)}` : baseUrl
}

export const navigateToBilling = (cta: string | undefined): void => {
  navigateTo(getBillingUrl(cta))
}
